import { Controller } from "@hotwired/stimulus"

// Simple controller to trigger the cookie consent preferences modal
export default class extends Controller {
  openPreferences() {
    // Dispatch a custom event that the cookie-consent controller listens to
    window.dispatchEvent(new CustomEvent('openCookiePreferences'))
  }
}
